// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Your web app's Firebase configuration
// Replace with your actual Firebase config values
const firebaseConfig = {
  apiKey: "AIzaSyDykFG49avorfmdld1Th07tnFqgGu6yN4c",
  authDomain: "skippy-customer-app-c3491.firebaseapp.com",
  projectId: "skippy-customer-app-c3491",
  storageBucket: "skippy-customer-app-c3491.firebasestorage.app",
  messagingSenderId: "498394071115",
  appId: "1:498394071115:web:9b634553c833a0e6864dce",
  measurementId: "G-XGLTC8GRJ4",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Export initialization function
export const initializeFirebase = () => {
  return { app, messaging };
};

// Request permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    // Check if notification permission is already granted
    if (Notification.permission === 'granted') {
      return getTokenAndSave();
    }
    
    // Check if permission is denied (blocked)
    if (Notification.permission === 'denied') {
      console.warn('Notifications are blocked. Please enable them in your browser settings.');
      alert('Notifications are blocked. To enable them: Click the lock icon in the address bar → Site Settings → Notifications → Allow');
      return null;
    }
    
    // Request permission
    const permission = await Notification.requestPermission();
    
    if (permission === 'granted') {
      return getTokenAndSave();
    } else {
      console.log('Notification permission denied');
      return null;
    }
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return null;
  }
};

// Get FCM token and save it
const getTokenAndSave = async () => {
  try {
    // Get registration token
    const currentToken = await getToken(messaging, {
      vapidKey: 'BDKeOH2Sdi9sd45oS62xL03lwbLV0aSkBYlBfcmRGHCGQ7rRI5wweVh5k2RRX1fWKi2Z7eLZ-_DlYjhXery-mYs' // Replace with your VAPID key
    });
    
    if (currentToken) {
      // Send the token to your server
      console.log('FCM token:', currentToken);
      saveTokenToServer(currentToken);
      localStorage.setItem('fcmToken', currentToken);
      return currentToken;
    } else {
      console.log('No registration token available');
      return null;
    }
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

// Save token to your server
const saveTokenToServer = (token) => {
  // TODO: Implement saving token to your server
  // You can use your existing API services to send the token to your backend
  console.log('Saving token to server:', token);
};

// Handle foreground messages
export const onMessageListener = () => {
  return new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log('Message received in foreground:', payload);
      resolve(payload);
    });
  });
};

export default app;
